// extracted by mini-css-extract-plugin
export default {"layout":"b19e8a622f _249fec016f _778e5b53c2","h_slide":"d9c7a5aa26","category":"c552badbdd _4259d1bd1e a07f014079"};